import React from 'react';
import { Bar, Polar } from 'react-chartjs-2';

function GraficosAsignacion(props) {

    const opciones = {
        plugins: {
            title: {
                display: true,
                text: '',
            },
        },
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };


    const datos = {
        labels: props.valores,
        datasets: [
            {
                label: 'Asignados',
                data: props.asignados,
                backgroundColor: 'rgba(53, 162, 235)',
                stack: 'Stack 1',
            },
            {
                label: 'Vendidos',
                data: props.vendidos,
                backgroundColor: 'rgba(54, 227, 139)',
                stack: 'Stack 2',
            },
            {
                label: 'Enterados',
                data: props.enterados,
                backgroundColor: 'rgba(255, 99, 132)',
                stack: 'Stack 3',
            }
        ],
    };

    const data = {
        labels: props.valores,
        datasets: [
          {
            label: '# of Votes',
            data: props.vendidos,
            backgroundColor: [
              'rgba(255, 99, 132, 0.5)',
              'rgba(54, 162, 235, 0.5)',
              'rgba(255, 206, 86, 0.5)',
              'rgba(75, 192, 192, 0.5)',
              'rgba(153, 102, 255, 0.5)',
              'rgba(255, 159, 64, 0.5)',
            ],
            borderWidth: 1,
          },
        ],
      };


    return (
        <div className="container-fluid px-3 py-2">
            <div className="row col-12">
                <div className="col-md-6" style={{ backgroundColor: 'white', boxShadow: '0px 0px 10px 1px #aaaaaa' }}>
                    <div className="row py-0 my-0 m-0">
                        <h5 className="m-0 second-text" style={{fontFamily: 'Georgia'}}>{props.tipo === 'TF' ? 'Timbres' : 'Guias'}: Asignados/Vendidos/Enterados</h5>
                        <hr className='w-50 my-0' />
                    </div>
                     <Bar options={opciones} data={datos} /> 
                </div>
                 <div className='col-md-6' style={{ backgroundColor: 'white', boxShadow: '0px 0px 10px 1px #aaaaaa' }}>
                 <div className="row py-0 my-0 m-0">
                        <h5 className="m-0 second-text" style={{fontFamily: 'Georgia'}}>{props.tipo === 'TF' ? 'Timbres Vendidos' : 'Guias Vendidas'}</h5>
                        <hr className='w-50 my-0' />
                    </div>
                <Polar data={data}/>
                </div> 
            </div>
        </div>
    );

}

export default GraficosAsignacion;

////////////////////#####$$$$$#####//////////////////////
/////#####Graficos de Asignacion de Timbres#####/////////
/////////#####Programador: Cesar Ratia#####/////////////
///////////#####Empresa: Sygre.ca#####/////////////////
/////////////////#####$$$$$#####//////////////////////


// WEBPACK FOOTER //
// ./src/components/timbres/graficosAsignacionTimbres.js